/**
 * Os anos oferecidos nos campos de "Ano do Modelo" (at-62, D1).
 *
 * Extraído porque estava em **dois** formulários com implementações diferentes:
 * `components/carro/FormularioVeiculo` gerava 31 anos (`for` do corrente até
 * corrente−30) e `views/cotacao` gerava 30 (`Array.from({length: 30})`). Os dois
 * campos alimentam a MESMA consulta à FIPE (`ModalVeiculos`, que é indexado por
 * ano), então listas diferentes só podiam ser descuido.
 *
 * ⚠️ **A cotação passou a oferecer 31 anos** (um a mais que antes). É a única
 * diferença de comportamento da unificação, e vai no sentido de deixar cotar um
 * veículo que a adesão já aceitava.
 */
export function anosDisponiveis(): string[] {
  const atual = new Date().getFullYear();
  const anos: string[] = [];
  /*
   * at-81: começa no ano SEGUINTE. Veículo 0km costuma ser vendido com o
   * ano-modelo do ano que vem (um 2027 comprado em novembro de 2026) — sem isto ele
   * simplesmente não aparecia para seleção. Se a FIPE ainda não tiver o modelo
   * naquele ano, o modal de modelos já diz isso (lista vazia explicada).
   */
  for (let i = atual + 1; i >= atual - 30; i -= 1) anos.push(String(i));

  return anos;
}
